'use strict';

module.exports = strikethrough;

function strikethrough(node) {
  return '~~' + this.all(node).join('') + '~~';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/delete.js
// module id = 963
// module chunks = 95715928098905 168707334958949